// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.becker-campaign-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(5, 12, 30, 0.76);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
}

.becker-campaign-popup {
  position: relative;
  width: 100%;
  max-width: 1050px;
  max-height: min(92vh, 850px);
  max-height: min(92dvh, 850px);
  overflow-y: auto;
  overscroll-behavior: contain;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  background: #0b1735;
  color: #ffffff;
  box-shadow: 0 25px 90px rgba(0, 0, 0, 0.4);
  scrollbar-width: thin;
  scrollbar-color: #51617d transparent;
}

.becker-campaign-close {
  position: absolute;
  top: 14px;
  right: 16px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s;
}
.becker-campaign-close:hover {
  background: rgba(255, 255, 255, 0.25);
}

.becker-campaign-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 24px 30px 18px;
}
.becker-campaign-header span {
  color: #ffffff;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 2px;
}
.becker-campaign-header small {
  color: #e6c785;
  font-size: 10px;
  letter-spacing: 2px;
}

.becker-campaign-tabs {
  display: flex;
  gap: 8px;
  padding: 0 30px 20px;
}
.becker-campaign-tabs button {
  flex: 1 1;
  padding: 11px 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: #24375c;
  color: #cbd5e7;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.becker-campaign-tabs button:hover {
  background: #344970;
}
.becker-campaign-tabs button.active {
  border-color: #e6c785;
  background: #e6c785;
  color: #152046;
  font-weight: 700;
}

.becker-campaign-content {
  display: grid;
  grid-template-columns: 52% 48%;
  min-height: 0;
  padding: 0 30px 24px;
}

.becker-campaign-image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
  overflow: hidden;
  background: #152046;
  border-radius: 12px 0 0 12px;
}
.becker-campaign-image img {
  position: static;
  display: block;
  width: 100%;
  height: auto;
  max-height: 70vh;
  max-height: 70dvh;
  object-fit: contain;
  object-position: center;
}
.becker-campaign-image::after {
  display: none;
}

.becker-campaign-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 28px 30px;
  border-radius: 0 12px 12px 0;
  background: #182b4e;
}

.becker-campaign-label {
  margin-bottom: 12px;
  color: #e6c785;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
}

.becker-campaign-info h2 {
  margin: 0 0 8px;
  color: #ffffff;
  font-size: clamp(23px, 2.5vw, 31px);
  font-weight: 700;
  line-height: 1.35;
}

.becker-campaign-info h3 {
  margin: 0 0 14px;
  color: #e6c785;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
}

.becker-campaign-info p {
  margin: 0 0 22px;
  color: #c4d0e4;
  font-size: 13px;
  line-height: 1.9;
}

.becker-campaign-countdown {
  margin-bottom: 20px;
}

.becker-countdown-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #dbe3f1;
  font-size: 12px;
}

.becker-countdown-dot,
.becker-news-dot {
  width: 7px;
  height: 7px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #e6c785;
  box-shadow: 0 0 10px rgba(230, 199, 133, 0.5);
}

.becker-countdown-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.becker-countdown-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 12px 3px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 8px;
  background: #2a4067;
}
.becker-countdown-item strong {
  color: #ffffff;
  font-size: clamp(18px, 2vw, 25px);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
}
.becker-countdown-item span {
  color: #b7c5dc;
  font-size: 11px;
}

.becker-campaign-deadline {
  margin-top: 10px;
  color: #aebed7;
  font-size: 11px;
  text-align: center;
}

.becker-campaign-news {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 22px;
  padding: 16px;
  border: 1px solid rgba(230, 199, 133, 0.22);
  border-radius: 8px;
  background: rgba(230, 199, 133, 0.08);
  color: #e6c785;
  font-size: 13px;
}

.becker-campaign-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 48px;
  padding: 12px 18px;
  border: 0;
  border-radius: 8px;
  background: #e6c785;
  color: #152046;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}
.becker-campaign-cta:hover {
  background: #f5dca5;
  color: #152046;
  text-decoration: none;
  transform: translateY(-2px);
}
.becker-campaign-cta span {
  font-size: 20px;
}
.becker-campaign-cta.disabled {
  justify-content: center;
  background: #52617b;
  color: #d3d9e3;
  cursor: not-allowed;
}
.becker-campaign-cta.disabled:hover {
  transform: none;
  background: #52617b;
}

.becker-campaign-footer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 0 30px 20px;
  color: #8193b3;
  font-size: 10px;
  letter-spacing: 1px;
}

.becker-campaign-floating {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9990;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 12px 17px;
  border: 1px solid rgba(230, 199, 133, 0.55);
  border-radius: 40px;
  background: #152046;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.25);
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.becker-campaign-floating:hover {
  background: #213465;
}

.becker-floating-icon {
  color: #e6c785;
  font-size: 18px;
}

.becker-floating-count {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 21px;
  height: 21px;
  padding: 0 5px;
  border-radius: 50%;
  background: #e6c785;
  color: #152046;
  font-size: 11px;
  font-weight: 700;
}

@media (max-width: 768px) {
  .becker-campaign-popup {
    max-width: 560px;
  }
  .becker-campaign-content {
    grid-template-columns: 1fr;
    padding: 0 20px 20px;
  }
  .becker-campaign-image {
    height: 190px;
    min-height: 190px;
    border-radius: 12px 12px 0 0;
  }
  .becker-campaign-info {
    padding: 24px;
    border-radius: 0 0 12px 12px;
  }
  .becker-campaign-header {
    padding: 20px 20px 16px;
  }
  .becker-campaign-tabs {
    padding: 0 20px 16px;
  }
  .becker-campaign-footer {
    padding: 0 20px 20px;
  }
}
@media (max-width: 480px) {
  .becker-campaign-overlay {
    align-items: center;
    padding: 12px;
  }
  .becker-campaign-popup {
    max-height: 90vh;
    max-height: 90dvh;
    border-radius: 15px;
  }
  .becker-campaign-header {
    padding: 18px 16px 14px;
  }
  .becker-campaign-header span {
    font-size: 14px;
  }
  .becker-campaign-header small {
    font-size: 9px;
  }
  .becker-campaign-close {
    top: 12px;
    right: 12px;
    width: 30px;
    height: 30px;
    font-size: 23px;
  }
  .becker-campaign-tabs {
    gap: 5px;
    padding: 0 14px 14px;
  }
  .becker-campaign-tabs button {
    padding: 10px 4px;
    font-size: 12px;
  }
  .becker-campaign-content {
    padding: 0 14px 16px;
  }
  .becker-campaign-image {
    height: 145px;
    min-height: 145px;
  }
  .becker-campaign-info {
    padding: 20px 16px;
  }
  .becker-campaign-label {
    margin-bottom: 8px;
    font-size: 10px;
  }
  .becker-campaign-info h2 {
    font-size: 23px;
  }
  .becker-campaign-info h3 {
    margin-bottom: 9px;
    font-size: 14px;
  }
  .becker-campaign-info p {
    margin-bottom: 15px;
    font-size: 12px;
    line-height: 1.7;
  }
  .becker-countdown-item {
    padding: 10px 2px;
  }
  .becker-countdown-item strong {
    font-size: 20px;
  }
  .becker-campaign-footer {
    padding: 0 14px 16px;
    font-size: 9px;
  }
  .becker-campaign-floating {
    right: 15px;
    bottom: 15px;
    padding: 10px 13px;
    font-size: 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .becker-campaign-popup *,
  .becker-campaign-floating {
    transition: none !important;
  }
}
/* 手機版：最新優惠按鈕移到客服列與回頂部按鈕上方 */
@media (max-width: 768px) {
  .becker-campaign-floating {
    position: fixed !important;
    right: 16px !important;
    bottom: calc(150px + env(safe-area-inset-bottom, 0px)) !important;
    top: auto !important;
    left: auto !important;
    z-index: 1100;
    padding: 10px 14px;
    font-size: 12px;
    white-space: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/styles/homeCampaignPopup.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAOhB;EACE,eAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iCAAA;EACA,0BAAA;EACA,kCAAA;AALF;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBA5BU;EA6BV,cA1BM;EA2BN,0CAAA;EAEA,qBAAA;EACA,oCAAA;AANF;;AASA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,0CAAA;EACA,kBAAA;EACA,oCAAA;EACA,cA/CM;EAgDN,eAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;AANF;AAQE;EACE,qCAAA;AANJ;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AAPF;AASE;EACE,cAjEI;EAkEJ,eAAA;EACA,gBAAA;EACA,mBAAA;AAPJ;AAUE;EACE,cAzEG;EA0EH,eAAA;EACA,mBAAA;AARJ;;AAYA;EACE,aAAA;EACA,QAAA;EACA,oBAAA;AATF;AAWE;EACE,SAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBAAA;EACA,mBA1FS;EA2FT,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AATJ;AAWI;EACE,mBAAA;AATN;AAYI;EACE,qBArGC;EAsGD,mBAtGC;EAuGD,cA1GC;EA2GD,gBAAA;AAVN;;AAeA;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,oBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;AAZF;AAcE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AAZJ;AAeE;EACE,aAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,cAzJK;EA0JL,eAAA;EACA,gBAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,cAhKM;EAiKN,mCAAA;EACA,gBAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,cAzKK;EA0KL,eAAA;EACA,gBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAdF;;AAiBA;;EAEE,UAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAzMK;EA0ML,6CAAA;AAdF;;AAiBA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBAAA;EACA,mBAAA;AAdF;AAgBE;EACE,cA9NI;EA+NJ,iCAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,cAAA;EACA,eAAA;AAfJ;;AAmBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;EACA,qCAAA;EACA,cA5PK;EA6PL,eAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAzQK;EA0QL,cA7QK;EA8QL,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AAhBF;AAkBE;EACE,mBAAA;EACA,cAtRG;EAuRH,qBAAA;EACA,2BAAA;AAhBJ;AAmBE;EACE,eAAA;AAjBJ;AAoBE;EACE,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAlBJ;AAoBI;EACE,eAAA;EACA,mBAAA;AAlBN;;AAuBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AApBF;;AAwBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAlUK;EAmUL,0CAAA;EACA,cAhUM;EAiUN,eAAA;EACA,gBAAA;EACA,eAAA;AArBF;AAuBE;EACE,mBAAA;AArBJ;;AAyBA;EACE,cA5UK;EA6UL,eAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAxVK;EAyVL,cA5VK;EA6VL,eAAA;EACA,gBAAA;AAtBF;;AA0BA;EACE;IACE,gBAAA;EAvBF;EA0BA;IACE,0BAAA;IACA,oBAAA;EAxBF;EA2BA;IACE,aAAA;IACA,iBAAA;IACA,4BAAA;EAzBF;EA4BA;IACE,aAAA;IACA,4BAAA;EA1BF;EA6BA;IACE,uBAAA;EA3BF;EA8BA;IACE,oBAAA;EA5BF;EA+BA;IACE,oBAAA;EA7BF;AACF;AAiCA;EACE;IACE,mBAAA;IACA,aAAA;EA/BF;EAkCA;IACE,gBAAA;IACA,iBAAA;IACA,mBAAA;EAhCF;EAmCA;IACE,uBAAA;EAjCF;EAmCE;IACE,eAAA;EAjCJ;EAoCE;IACE,cAAA;EAlCJ;EAsCA;IACE,SAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EApCF;EAuCA;IACE,QAAA;IACA,oBAAA;EArCF;EAuCE;IACE,iBAAA;IACA,eAAA;EArCJ;EAyCA;IACE,oBAAA;EAvCF;EA0CA;IACE,aAAA;IACA,iBAAA;EAxCF;EA2CA;IACE,kBAAA;EAzCF;EA4CA;IACE,kBAAA;IACA,eAAA;EA1CF;EA6CA;IACE,eAAA;EA3CF;EA8CA;IACE,kBAAA;IACA,eAAA;EA5CF;EA+CA;IACE,mBAAA;IACA,eAAA;IACA,gBAAA;EA7CF;EAgDA;IACE,iBAAA;EA9CF;EAgDE;IACE,eAAA;EA9CJ;EAkDA;IACE,oBAAA;IACA,cAAA;EAhDF;EAmDA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;EAjDF;AACF;AAoDA;EACE;;IAEE,2BAAA;EAlDF;AACF;AAqDA,4BAAA;AACA;EACE;IACE,0BAAA;IAEA,sBAAA;IACA,iEAAA;IAEA,oBAAA;IACA,qBAAA;IAEA,aAAA;IAEA,kBAAA;IACA,eAAA;IACA,mBAAA;EAvDF;AACF","sourcesContent":["\r\n$navy: #152046;\r\n$navy-dark: #0b1735;\r\n$navy-light: #24375c;\r\n$gold: #e6c785;\r\n$white: #ffffff;\r\n\r\n.becker-campaign-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 99999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  background: rgba(5, 12, 30, 0.76);\r\n  backdrop-filter: blur(7px);\r\n  -webkit-backdrop-filter: blur(7px);\r\n}\r\n\r\n.becker-campaign-popup {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 1050px;\r\n  max-height: min(92vh, 850px);\r\n  max-height: min(92dvh, 850px);\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: 20px;\r\n  background: $navy-dark;\r\n  color: $white;\r\n  box-shadow: 0 25px 90px rgba(0, 0, 0, 0.4);\r\n\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #51617d transparent;\r\n}\r\n\r\n.becker-campaign-close {\r\n  position: absolute;\r\n  top: 14px;\r\n  right: 16px;\r\n  z-index: 10;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  padding: 0;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 50%;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: $white;\r\n  font-size: 26px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n\r\n  &:hover {\r\n    background: rgba(255, 255, 255, 0.25);\r\n  }\r\n}\r\n\r\n.becker-campaign-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  padding: 24px 30px 18px;\r\n\r\n  span {\r\n    color: $white;\r\n    font-size: 17px;\r\n    font-weight: 700;\r\n    letter-spacing: 2px;\r\n  }\r\n\r\n  small {\r\n    color: $gold;\r\n    font-size: 10px;\r\n    letter-spacing: 2px;\r\n  }\r\n}\r\n\r\n.becker-campaign-tabs {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 0 30px 20px;\r\n\r\n  button {\r\n    flex: 1;\r\n    padding: 11px 8px;\r\n    border: 1px solid rgba(255, 255, 255, 0.12);\r\n    border-radius: 8px;\r\n    background: $navy-light;\r\n    color: #cbd5e7;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n\r\n    &:hover {\r\n      background: #344970;\r\n    }\r\n\r\n    &.active {\r\n      border-color: $gold;\r\n      background: $gold;\r\n      color: $navy;\r\n      font-weight: 700;\r\n    }\r\n  }\r\n}\r\n\r\n.becker-campaign-content {\r\n  display: grid;\r\n  grid-template-columns: 52% 48%;\r\n  min-height: 0;\r\n  padding: 0 30px 24px;\r\n}\r\n\r\n.becker-campaign-image {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  background: #152046;\r\n  border-radius: 12px 0 0 12px;\r\n\r\n  img {\r\n    position: static;\r\n    display: block;\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 70vh;\r\n    max-height: 70dvh;\r\n    object-fit: contain;\r\n    object-position: center;\r\n  }\r\n\r\n  &::after {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.becker-campaign-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  padding: 28px 30px;\r\n  border-radius: 0 12px 12px 0;\r\n  background: #182b4e;\r\n}\r\n\r\n.becker-campaign-label {\r\n  margin-bottom: 12px;\r\n  color: $gold;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  letter-spacing: 2px;\r\n}\r\n\r\n.becker-campaign-info h2 {\r\n  margin: 0 0 8px;\r\n  color: $white;\r\n  font-size: clamp(23px, 2.5vw, 31px);\r\n  font-weight: 700;\r\n  line-height: 1.35;\r\n}\r\n\r\n.becker-campaign-info h3 {\r\n  margin: 0 0 14px;\r\n  color: $gold;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  line-height: 1.5;\r\n}\r\n\r\n.becker-campaign-info p {\r\n  margin: 0 0 22px;\r\n  color: #c4d0e4;\r\n  font-size: 13px;\r\n  line-height: 1.9;\r\n}\r\n\r\n.becker-campaign-countdown {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.becker-countdown-heading {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n  color: #dbe3f1;\r\n  font-size: 12px;\r\n}\r\n\r\n.becker-countdown-dot,\r\n.becker-news-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  flex-shrink: 0;\r\n  border-radius: 50%;\r\n  background: $gold;\r\n  box-shadow: 0 0 10px rgba(230, 199, 133, 0.5);\r\n}\r\n\r\n.becker-countdown-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 8px;\r\n}\r\n\r\n.becker-countdown-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n  min-width: 0;\r\n  padding: 12px 3px;\r\n  border: 1px solid rgba(255, 255, 255, 0.07);\r\n  border-radius: 8px;\r\n  background: #2a4067;\r\n\r\n  strong {\r\n    color: $white;\r\n    font-size: clamp(18px, 2vw, 25px);\r\n    font-weight: 700;\r\n    font-variant-numeric: tabular-nums;\r\n    line-height: 1.2;\r\n  }\r\n\r\n  span {\r\n    color: #b7c5dc;\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n.becker-campaign-deadline {\r\n  margin-top: 10px;\r\n  color: #aebed7;\r\n  font-size: 11px;\r\n  text-align: center;\r\n}\r\n\r\n.becker-campaign-news {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 22px;\r\n  padding: 16px;\r\n  border: 1px solid rgba(230, 199, 133, 0.22);\r\n  border-radius: 8px;\r\n  background: rgba(230, 199, 133, 0.08);\r\n  color: $gold;\r\n  font-size: 13px;\r\n}\r\n\r\n.becker-campaign-cta {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  min-height: 48px;\r\n  padding: 12px 18px;\r\n  border: 0;\r\n  border-radius: 8px;\r\n  background: $gold;\r\n  color: $navy;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n\r\n  &:hover {\r\n    background: #f5dca5;\r\n    color: $navy;\r\n    text-decoration: none;\r\n    transform: translateY(-2px);\r\n  }\r\n\r\n  span {\r\n    font-size: 20px;\r\n  }\r\n\r\n  &.disabled {\r\n    justify-content: center;\r\n    background: #52617b;\r\n    color: #d3d9e3;\r\n    cursor: not-allowed;\r\n\r\n    &:hover {\r\n      transform: none;\r\n      background: #52617b;\r\n    }\r\n  }\r\n}\r\n\r\n.becker-campaign-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  padding: 0 30px 20px;\r\n  color: #8193b3;\r\n  font-size: 10px;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n// 右下角優惠入口\r\n.becker-campaign-floating {\r\n  position: fixed;\r\n  right: 24px;\r\n  bottom: 24px;\r\n  z-index: 9990;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  padding: 12px 17px;\r\n  border: 1px solid rgba(230, 199, 133, 0.55);\r\n  border-radius: 40px;\r\n  background: $navy;\r\n  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.25);\r\n  color: $white;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    background: #213465;\r\n  }\r\n}\r\n\r\n.becker-floating-icon {\r\n  color: $gold;\r\n  font-size: 18px;\r\n}\r\n\r\n.becker-floating-count {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 21px;\r\n  height: 21px;\r\n  padding: 0 5px;\r\n  border-radius: 50%;\r\n  background: $gold;\r\n  color: $navy;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n}\r\n\r\n// 平板\r\n@media (max-width: 768px) {\r\n  .becker-campaign-popup {\r\n    max-width: 560px;\r\n  }\r\n\r\n  .becker-campaign-content {\r\n    grid-template-columns: 1fr;\r\n    padding: 0 20px 20px;\r\n  }\r\n\r\n  .becker-campaign-image {\r\n    height: 190px;\r\n    min-height: 190px;\r\n    border-radius: 12px 12px 0 0;\r\n  }\r\n\r\n  .becker-campaign-info {\r\n    padding: 24px;\r\n    border-radius: 0 0 12px 12px;\r\n  }\r\n\r\n  .becker-campaign-header {\r\n    padding: 20px 20px 16px;\r\n  }\r\n\r\n  .becker-campaign-tabs {\r\n    padding: 0 20px 16px;\r\n  }\r\n\r\n  .becker-campaign-footer {\r\n    padding: 0 20px 20px;\r\n  }\r\n}\r\n\r\n// 手機\r\n@media (max-width: 480px) {\r\n  .becker-campaign-overlay {\r\n    align-items: center;\r\n    padding: 12px;\r\n  }\r\n\r\n  .becker-campaign-popup {\r\n    max-height: 90vh;\r\n    max-height: 90dvh;\r\n    border-radius: 15px;\r\n  }\r\n\r\n  .becker-campaign-header {\r\n    padding: 18px 16px 14px;\r\n\r\n    span {\r\n      font-size: 14px;\r\n    }\r\n\r\n    small {\r\n      font-size: 9px;\r\n    }\r\n  }\r\n\r\n  .becker-campaign-close {\r\n    top: 12px;\r\n    right: 12px;\r\n    width: 30px;\r\n    height: 30px;\r\n    font-size: 23px;\r\n  }\r\n\r\n  .becker-campaign-tabs {\r\n    gap: 5px;\r\n    padding: 0 14px 14px;\r\n\r\n    button {\r\n      padding: 10px 4px;\r\n      font-size: 12px;\r\n    }\r\n  }\r\n\r\n  .becker-campaign-content {\r\n    padding: 0 14px 16px;\r\n  }\r\n\r\n  .becker-campaign-image {\r\n    height: 145px;\r\n    min-height: 145px;\r\n  }\r\n\r\n  .becker-campaign-info {\r\n    padding: 20px 16px;\r\n  }\r\n\r\n  .becker-campaign-label {\r\n    margin-bottom: 8px;\r\n    font-size: 10px;\r\n  }\r\n\r\n  .becker-campaign-info h2 {\r\n    font-size: 23px;\r\n  }\r\n\r\n  .becker-campaign-info h3 {\r\n    margin-bottom: 9px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .becker-campaign-info p {\r\n    margin-bottom: 15px;\r\n    font-size: 12px;\r\n    line-height: 1.7;\r\n  }\r\n\r\n  .becker-countdown-item {\r\n    padding: 10px 2px;\r\n\r\n    strong {\r\n      font-size: 20px;\r\n    }\r\n  }\r\n\r\n  .becker-campaign-footer {\r\n    padding: 0 14px 16px;\r\n    font-size: 9px;\r\n  }\r\n\r\n  .becker-campaign-floating {\r\n    right: 15px;\r\n    bottom: 15px;\r\n    padding: 10px 13px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .becker-campaign-popup *,\r\n  .becker-campaign-floating {\r\n    transition: none !important;\r\n  }\r\n}\r\n\r\n/* 手機版：最新優惠按鈕移到客服列與回頂部按鈕上方 */\r\n@media (max-width: 768px) {\r\n  .becker-campaign-floating {\r\n    position: fixed !important;\r\n\r\n    right: 16px !important;\r\n    bottom: calc(150px + env(safe-area-inset-bottom, 0px)) !important;\r\n\r\n    top: auto !important;\r\n    left: auto !important;\r\n\r\n    z-index: 1100;\r\n\r\n    padding: 10px 14px;\r\n    font-size: 12px;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
